import { html, TemplateResult } from "lit";
import { UIUtilTime } from "../util/Time";
import { MCicloEscolar } from "../../data/model/MCicloEscolar";

export namespace UIUtilViewCicloEscolar {
    type ICicloEscolarUIBasico = Pick<MCicloEscolar, "Nombre" | "FechaInicio" | "FechaFin" | "IdEscuela">;
    /**
     * Renderiza un item básico de ciclo escolar, mostrando su nombre y fechas de inicio y fin.
     */
    export function _RenderCicloEscolarBasicItemUI({ Nombre, FechaInicio, FechaFin, IdEscuela }: ICicloEscolarUIBasico, templatesExtras?: TemplateResult[]) {
        return html`
        <div style="display: flex; flex-direction: column;">
            <span>
                ${Nombre}
            </span>
            <span style="font-size: var(--fontsize_me4); font-family: 'Lato-Light';">
                ${UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(FechaInicio, IdEscuela)} - ${UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(FechaFin, IdEscuela)}
            </span>
            ${templatesExtras ? templatesExtras.map(template => template) : ''}
        </div>
        `;
    }
}